import { isSabilOutstandingBroadcastEnabledForTenant } from "@/utils/sabil-outstanding-broadcast";
import { useTenantFeatureGate } from "./use-tenant-feature-gate";

/**
 * Whether Sabil Outstanding broadcast mode is available for the effective tenant
 * (JWT `tenantId`, or `localStorage.impersonatedTenantId` for super-admin).
 */
export function useIsSabilOutstandingBroadcastEnabled(): boolean {
  return useTenantFeatureGate(isSabilOutstandingBroadcastEnabledForTenant);
}
